import React from 'react';

export const BottomBar = () => {
  return (
    <div className="w-screen bg-white py-10 text-sm text-gray-800">
      <div className="mx-auto max-w-screen-2xl px-4">
      사단법인 녹색에너지전략연구소 | 사업자등록번호 220-82-11150‌ | Tel. 02-552-0940 | E-mail. gesi@gesi.kr |<br/>
      주소 05836 서울특별시 송파구 법원로 11길 25, H비지니스파크 B동 515‌호 <br/><br/>
      COPYRIGHT ‌GESI 2020. ALL RIGHTS RESERVED.
      </div>
    </div>
  );
};
